export default "__VITE_ASSET__C5wvdi7W__"